/** Контакты Суперфуд Фарм (с витрины OpenCart) */
export const SITE_CONTACT = {
  phone: '+7 929 672 28 62',
  phoneHref: 'tel:+79296722862',
  email: 'superfoodfarm@ya.ru',
  emailHref: 'mailto:superfoodfarm@ya.ru',
  address: 'Московская область, Дмитров',
  tagline: '#НОВЕЙШИЙФЕРМЕР',
  whatsappHref: 'https://wa.me/79296722862',
} as const
